import { Grid, Stack } from "@mui/material";
import React, { useState } from "react";

import style from "./index.module.css";

import Title from "@/components/Title";
import Button from "@/components/Button";
import MedicineTestSuggestions from "@/components/Prescription/MedicineTestSuggestions";
import GetImages from "@/components/GetImages";
import MedicineTestListRemoveManagerWeb from "@/components/Prescription/MedicineTestListRemoveManagerWeb";

import { IButtonVariant } from "@/models/button";
import {
  IMedicineTestSuggestionData,
  ITitleInputValuesListEnums,
} from "@/models/doctor";

import { useAppDispatch, useAppSelector } from "@/store/hooks";
import {
  setPrescriptionTemplate,
  setPrescriptionValues,
} from "@/store/slices/doctor/prescription";

const medicineTestInputSuggestionConfig = [
  {
    title: "Medicines",
    type: ITitleInputValuesListEnums.MEDICINE,
    buttonInput: {
      label: "Medicine",
      detail: { icon: "MedicineSmallIcon", label: "Add Medicine" },
    },
  },
  {
    title: "Tests",
    type: ITitleInputValuesListEnums.TEST,
    buttonInput: {
      label: "Test",
      detail: { icon: "TestSmallIcon", label: "Add Test" },
    },
  },
];

const MedicineTestInputSuggestion: React.FC = () => {
  const [medicineTestInputShowType, setMedicineTestInputShowType] =
    useState<ITitleInputValuesListEnums | null>(null);

  const dispatch = useAppDispatch();

  const { isTemplatesOpen } = useAppSelector(
    (state) => state.topNavigation.topBarItems
  );
  const { template } = useAppSelector((state) => state.prescription);
  const { create }: any = template;

  const getMedicineTestDetailHandler = (
    detail: IMedicineTestSuggestionData,
    identifier: ITitleInputValuesListEnums
  ) => {
    const isMedicine = identifier === ITitleInputValuesListEnums.MEDICINE;
    const { medicineId, testId, name } = detail;

    if (isTemplatesOpen) {
      dispatch(
        setPrescriptionTemplate({
          identifier,
          value: isMedicine ? [{ name, medicineId }] : [{ name, testId }],
        })
      );
    } else {
      dispatch(
        setPrescriptionValues({
          identifier,
          value: isMedicine ? [{ name, medicineId }] : [{ name, testId }],
        })
      );
    }

    setMedicineTestInputShowType(null);
  };

  const medicineTestInputShow = (type: ITitleInputValuesListEnums) => {
    setMedicineTestInputShowType(type);
  };

  return (
    <Grid item>
      {medicineTestInputSuggestionConfig.map((medicineTestDetail, index) => (
        <Grid item className={style.medicineTestContainer} key={index}>
          <Grid item textAlign={"left"} className={style.title}>
            <Title>{medicineTestDetail.title}</Title>
          </Grid>
          <Stack
            direction={
              medicineTestDetail.type === ITitleInputValuesListEnums.TEST
                ? "row"
                : "column"
            }
            flexWrap="wrap"
          >
            <Stack
              sx={{
                width: "100%",
              }}
              direction={
                medicineTestDetail.type === ITitleInputValuesListEnums.TEST
                  ? "row"
                  : "column"
              }
              columnGap={
                medicineTestDetail.type === ITitleInputValuesListEnums.TEST
                  ? 2
                  : 0
              }
              alignItems={
                medicineTestDetail.type === ITitleInputValuesListEnums.TEST
                  ? "start"
                  : "flex-start"
              }
              justifyContent="flex-start"
              flexWrap={
                medicineTestDetail.type === ITitleInputValuesListEnums.TEST
                  ? "wrap"
                  : "nowrap"
              }
            >
              <MedicineTestListRemoveManagerWeb
                medicineTestInputShowType={medicineTestInputShowType}
                type={medicineTestDetail.type}
              />
              {medicineTestInputShowType === medicineTestDetail?.type && (
                <Grid
                  sx={{
                    width:
                      medicineTestDetail.type ===
                        ITitleInputValuesListEnums.TEST &&
                      create[medicineTestDetail.type]?.length > 0
                        ? "fit-content"
                        : "100%",
                    mt: 2,
                  }}
                  item
                  className={style.medicineTestInputSuggestionContainer}
                >
                  <MedicineTestSuggestions
                    label={medicineTestDetail?.buttonInput.detail.label}
                    type={medicineTestDetail?.type}
                    getMedicineTestDetailEnterEventHandler={
                      getMedicineTestDetailHandler
                    }
                    closeSearch={() => setMedicineTestInputShowType(null)}
                  />
                </Grid>
              )}
              {medicineTestDetail.type === ITitleInputValuesListEnums.TEST && (
                <Grid
                  item
                  className={style.medicineTestBtnContainer}
                  sx={{
                    mt: "1.6rem",
                  }}
                >
                  <Button
                    variant={IButtonVariant.WHITE}
                    btnTrigger={() =>
                      medicineTestInputShow(medicineTestDetail?.type)
                    }
                  >
                    <GetImages
                      name={medicineTestDetail?.buttonInput?.detail?.icon}
                      width="26"
                      height="20"
                    />
                    {medicineTestDetail?.buttonInput?.detail?.label}
                  </Button>
                </Grid>
              )}
            </Stack>
            {medicineTestDetail.type ===
              ITitleInputValuesListEnums.MEDICINE && (
              <Grid
                item
                className={style.medicineTestBtnContainer}
                sx={{
                  mt: "1.6rem",
                }}
              >
                <Button
                  variant={IButtonVariant.WHITE}
                  btnTrigger={() =>
                    medicineTestInputShow(medicineTestDetail?.type)
                  }
                >
                  <GetImages
                    name={medicineTestDetail?.buttonInput?.detail?.icon}
                    width="26"
                    height="20"
                  />
                  {medicineTestDetail?.buttonInput?.detail?.label}
                </Button>
              </Grid>
            )}
          </Stack>
        </Grid>
      ))}
    </Grid>
  );
};

export default MedicineTestInputSuggestion;
